import React from 'react'
import "./langIcon.css"

const LangIcon = ({onclick}) => {
  return (
    <div className='langIcon' onClick={onclick}>Language</div>
  )
}

export default LangIcon